<template>
  <div class="mdl-grid">
    <div class="mdl-card mdl-cell mdl-cell--12-col mdl-shadow--2dp">
      <div class="attachmentContainer mdl-card fill">
        <div>
          <video v-if="media==='video'" v-el:video controls autoplay :src="attachmentSource" :type="contentType">
            <!--<source :src="attachmentSource" type="video/mp4"/>-->
            Your browser does not support the video tag.
          </video>
          <audio v-if="media==='audio'" v-el:audio controls :src="attachmentSource" :type="contentType">
            <!-- <source src="horse.ogg" type="audio/ogg"> -->
            Your browser does not support the audio element.
          </audio>
          <img v-if="media==='image'" v-el:image controls :src="attachmentSource" />
            <!-- <img src="img_chania.jpg" alt="Flowers in Chania"> -->
          <p v-if="media==='other'">
            <a :href="attachmentSource">{{attachmentName}}</a>
          </p>
        </div>
      </div>
    </div>
  </div>    
</template>

<script>
  var api = require('api')
  module.exports = {
    ready: function () {
      var self = this
      var token = this.$route.params.token
      api.File.getLink({token: token}).then(function (response) {
        var url = response.data.url
        self.attachmentSource = url
        self.contentType = response.data.contentType
        var partials = url.split('/')
        self.attachmentName = partials[partials.length - 1].split('?')[0]
        if (self.contentType.indexOf('video/') === 0) {
          self.media = 'video'
          self.$els.video.load()
        } else if (self.contentType.indexOf('audio/') === 0) {
          self.media = 'audio'
        } else if (self.contentType.indexOf('image/') === 0) {
          self.media = 'image'
        } else {
          self.media = 'other'
        }
      }, function (err) {
        self.$dispatch('show-error', err)
      })
    },
    data: function () {
      return {
        attachmentSource: '',
        attachmentName: '',
        contentType: 'video/mp4',
        media: 'other'
      }
    }
  }
</script>

<style scoped>
  .attachmentContainer {
    /* position: absolute;
    top: 0;
    bottom: 0; */
    margin: auto;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    padding: 5px;
    border: 1px solid gray;
  }
  .attachmentContainer > * {
    margin: auto;
  }
  .attachmentContainer > div > * {
    max-width: 100%;
  }
  .attachmentContainer > div > video {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// Attachment.vue?490392ca